import { APP_BASE_URL } from '../env';
import { COMPANY_ADDRESS, COMPANY_GEO, COMPANY_LOGO, COMPANY_NAME, COMPANY_TELEPHONE, } from './company/company_config';
export const baseJsonLdData = {
    '@context': 'https://schema.org',
};
// 記事構造化データ, https://developers.google.com/search/docs/advanced/structured-data/article?hl=ja
export const initialDataOfArticle = {
    '@type': 'NewsArticle',
    author: {},
    datePublished: '',
    headline: '',
    image: [],
    mainEntityOfPage: '',
};
// ロゴ構造化データ, https://developers.google.com/search/docs/advanced/structured-data/logo?hl=ja
export const initialDataOfOrganization = {
    '@type': 'Organization',
    logo: `${APP_BASE_URL}/images/logo_color.svg`,
    url: APP_BASE_URL,
};
// 会社概要構造化データ, https://developers.google.com/search/docs/advanced/structured-data/local-business?hl=ja
export const initialDataOfLocalBusiness = {
    '@type': 'LocalBusiness',
    address: Object.assign({ '@type': 'PostalAddress' }, COMPANY_ADDRESS),
    geo: Object.assign({ '@type': 'GeoCoordinates' }, COMPANY_GEO),
    image: [COMPANY_LOGO],
    name: COMPANY_NAME,
    telephone: COMPANY_TELEPHONE,
};
// パンくず構造化データ, https://developers.google.com/search/docs/advanced/structured-data/breadcrumb?hl=ja
export const initialDataOfBreadcrumbList = {
    '@type': 'BreadcrumbList',
    itemListElement: [],
};
// FAQ構造化データ, https://developers.google.com/search/docs/advanced/structured-data/faqpage?hl=ja
export const initialDataOfFaq = {
    '@type': 'FAQPage',
    mainEntity: [],
};
